export const selectPermissions = (state) => state.user.permissions;
export const selectEmail = (state) => state.user.email;
export const selectShowDeveloperContent = (state) => state.user.showDeveloperContent;
export const selectCanvasPermissions = (state) => state.user.canvasPermissions;
export const selectUserData = (state) => state.user.userData;
export const selectUserHash = (state) => state.user.userHash;
